import { useCallback, useMemo } from 'react';
import { PostModel } from '../../data-layer/posts/types';
import {
    SearchAppButtonType,
    ymTrackFeedCurtainButtonClick,
    ymTrackFeedCurtainButtonShown,
    ymTrackFeedCurtainProductClick,
    ymTrackFeedCurtainProductShown,
    ymTrackFeedCurtainShown,
} from '../../utils/metrika';

export const useSearchAppMetricsAnalytics = ({
    post,
    source,
}: {
    post?: PostModel;
    source?: 'business_catalog_page' | 'post_products_page';
}) => {
    const baseParams = useMemo(
        () => ({
            post_id: post?.id,
            business_id: post?.business?.id,
            source,
        }),
        [post, source],
    );

    const trackPageShown = useCallback(() => {
        ymTrackFeedCurtainShown({
            ...baseParams,
        });
    }, [baseParams]);

    const trackProductShown = useCallback(
        (productId: string, url: string) => {
            ymTrackFeedCurtainProductShown({
                ...baseParams,
                product_id: productId,
                clickout_url: url,
            });
        },
        [baseParams],
    );

    const trackProductClick = useCallback(
        (productId: string, url: string) => {
            ymTrackFeedCurtainProductClick({
                ...baseParams,
                product_id: productId,
                clickout_url: url,
            });
        },
        [baseParams],
    );

    const trackButtonShown = useCallback(
        (buttonType: SearchAppButtonType, url: string) => {
            ymTrackFeedCurtainButtonShown({
                ...baseParams,
                button_type: buttonType,
                clickout_url: url,
            });
        },
        [baseParams],
    );

    const trackButtonClick = useCallback(
        (buttonType: SearchAppButtonType, url: string) => {
            ymTrackFeedCurtainButtonClick({
                ...baseParams,
                button_type: buttonType,
                clickout_url: url,
            });
        },
        [baseParams],
    );

    return {
        trackPageShown,
        trackProductClick,
        trackButtonClick,
        trackProductShown,
        trackButtonShown,
    };
};
